import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard"}/>
}
